if(document.querySelector('.td-color-select')) {
    document.querySelector('.td-color-select').addEventListener('click', ()=> {
        if(document.querySelector('.webyzeProductColors')) {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    })
}

if (document.querySelectorAll('.td-how-it-fit__size-image').length > 0) {
    document.querySelectorAll('.td-how-it-fit__size-image').forEach(item => {
        item.addEventListener('click', () => {
            document.querySelector('.product-popup-modal__button').click();
        })
    })
};

setTimeout(() => {
    if (document.querySelector('.webyzeProductColors')) {
        const variantPickerHeading = document.querySelector('.td-product-variant-picker__variant-title');
        const colorSwatchHeading = variantPickerHeading.cloneNode(true);
        colorSwatchHeading.classList.add('td-color-swatch__heading');
        colorSwatchHeading.querySelectorAll('span')[0].innerText = "COLOR";
        const selectedColor = document.querySelector('.webyzeProductColors').querySelector('.swatchProductColor.currentSwatch .innerText').innerHTML.split(' - ')[1];
        colorSwatchHeading.querySelectorAll('span')[1].innerText = selectedColor;
        document.querySelector('.webyzeProductColors').prepend(colorSwatchHeading);

        const stickyColorSwatch = document.createElement('div');
        stickyColorSwatch.classList.add('product-form');
        stickyColorSwatch.classList.add('td-sticky-color-swatch');
        const label = document.createElement('label');
        label.classList.add('form__label');
        label.innerHTML = 'COLOR';
        stickyColorSwatch.append(label);
        const selectWrapper = document.createElement('div');
        selectWrapper.classList.add('select');
        const selectElement = document.createElement('select');
        selectElement.classList.add('select__select');
        document.querySelectorAll('.swatchProductColor').forEach((item) => {
            const value = item.querySelector('.innerText').innerHTML.split(' - ')[1];
            const option = document.createElement('option');
            option.setAttribute('value', value);
            option.setAttribute('data-handle', item.getAttribute('data-handle'));
            option.innerHTML = value;
            if (item.classList.contains('currentSwatch')) {
                option.setAttribute('selected', 'selected');

            }
            selectElement.append(option);

            const mobOption = document.createElement('div');
            mobOption.setAttribute('data-handle', item.getAttribute('data-handle'));
            const mobOptionText = document.createElement('p');
            mobOptionText.innerHTML = value;
            const itemImage = item.querySelector('div');
            itemImage.className = 'thumb-img';
            const mobOptionImage = itemImage.cloneNode(true);
            mobOption.append(mobOptionImage);
            mobOption.append(mobOptionText);


            const dskOption = document.createElement('div');
            dskOption.setAttribute('data-handle', item.getAttribute('data-handle'));
            const dskOptionText = document.createElement('p');
            dskOptionText.innerHTML = value;
            dskOption.append(dskOptionText);


            if (document.querySelector('.td-main-product__sticky-mobile-color-swatch')) {
                document.querySelector('.td-main-product__sticky-mobile-color-swatch').append(mobOption);
            }


            if (document.querySelector('.td-main-product__sticky-desktop-color-swatch')) {
                document.querySelector('.td-main-product__sticky-desktop-color-swatch').append(dskOption);
            }
        });
        selectWrapper.append(selectElement);
        const svg = document.createElement('svg');
        svg.classList.add('icon');
        svg.classList.add('icon-caret');
        selectWrapper.append(svg);
        stickyColorSwatch.append(selectWrapper);


        if (document.querySelector('.td-main-product__sticky-mobile-heading > img')) {
            document.querySelector('.td-main-product__sticky-mobile-heading > img').addEventListener('click', () => {
                toggleMobileColorSwatch();
            })
        }

        if (document.querySelector('.td-main-product__sticky-mobile-heading > svg')) {
            document.querySelector('.td-main-product__sticky-mobile-heading > svg').addEventListener('click', () => {
                toggleMobileColorSwatch();
            })
        }





        const desktopProductColorSelect = document.querySelector('.td-main-product__sticky-desktop-heading');

        if (document.querySelector('.td-main-product__color-swatch')) {
            document.addEventListener('click', (event) => {
                if (event.target.id === 'td-main-product__color-swatch') {
                    console.log('Desktop Color Swatch');
                    toggleDesktopColorSwatch();
                    // document.querySelector('.td-main-product__sticky-desktop-color-swatch').classList.add('active');
                }
                else if (!desktopProductColorSelect.contains(event.target)) {
                    document.querySelector('.td-main-product__sticky-desktop-color-swatch').classList.remove('active');
                    document.querySelector('.td-desktop-icon-arrow').classList.remove('active');
                }
            });
        }




        /*if (document.querySelector('.td-main-product__sticky-desktop-heading')) {
            document.querySelector('.td-main-product__sticky-desktop-heading').addEventListener('click', () => {
                toggleDesktopColorSwatch();
            })
        }*/

        if (document.querySelector('.td-main-product__sticky-mobile-color-swatch')) {
            document.querySelectorAll('.td-main-product__sticky-mobile-color-swatch > div').forEach((item) => {
                item.addEventListener('click', () => {
                    window.location.href = '/products/' + item.getAttribute('data-handle');
                })
            })
        }

        if (document.querySelector('.td-main-product__sticky-desktop-color-swatch')) {
            document.querySelectorAll('.td-main-product__sticky-desktop-color-swatch > div').forEach((item) => {
                item.addEventListener('click', () => {
                    window.location.href = '/products/' + item.getAttribute('data-handle');
                })
            })
        }

        function toggleDesktopColorSwatch() {
            const stickyDesktopColorSwatch = document.querySelector('.td-main-product__sticky-desktop-color-swatch');
            if (stickyDesktopColorSwatch) {
                if (stickyDesktopColorSwatch.classList.contains('active')) {
                    stickyDesktopColorSwatch.classList.remove('active');
                    document.querySelector('.td-desktop-icon-arrow').classList.remove('active');
                } else {
                    stickyDesktopColorSwatch.classList.add('active');
                    document.querySelector('.td-desktop-icon-arrow').classList.add('active');
                }
            }
        }

        function toggleMobileColorSwatch() {
            const stickyMobileColorSwatch = document.querySelector('.td-main-product__sticky-mobile-color-swatch');
            if (stickyMobileColorSwatch) {
                if (stickyMobileColorSwatch.classList.contains('active')) {
                    stickyMobileColorSwatch.classList.remove('active');
                    document.querySelector('.td-mobile-icon-arrow').classList.remove('active');
                } else {
                    stickyMobileColorSwatch.classList.add('active');
                    document.querySelector('.td-mobile-icon-arrow').classList.add('active');
                }
            }
        }
    }
}, 1500);


if (!customElements.get("td-out-of-stock-checkbox")) {
  class OOSCheckbox extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
    }

    connectedCallback() {
      setTimeout(() => {
        this.input.addEventListener('change', this.handleOOSVisibility.bind(this))
        document.addEventListener('td:variant-changed', this.handleOOSVisibility.bind(this))
      })
    }

    handleOOSVisibility({detail}) {
      console.log("FIRED",detail)
      const HIDDEN_CLASS = 'td-option--hidden'
      const radios = document.querySelectorAll('variant-radios')
      const selects = document.querySelectorAll('variant-selects')
      if (this.input.checked) {
        radios.forEach(radio => {
          radio.querySelectorAll('.product-form__input input[type="radio"] + label').forEach((label) => {
            if (label.classList.contains(HIDDEN_CLASS)) {
              label.classList.remove(HIDDEN_CLASS)
            }
          })
        })
        selects.forEach((select) => {
          select.querySelectorAll('option').forEach((option) => {
            if (option.classList.contains(HIDDEN_CLASS)) {
              option.classList.remove(HIDDEN_CLASS)
            }
          })
        })
      } else {
        const disabledOptions = []
        radios.forEach(radio => {
          let hasChanged = false
          const fieldsets = radio.querySelectorAll('fieldset')
          fieldsets.forEach((fieldset) => {
            fieldset.querySelectorAll('.product-form__input input[type="radio"].disabled + label').forEach((label) => {
              disabledOptions.push(document.getElementById(label.getAttribute('for')).value)
              if (!label.classList.contains(HIDDEN_CLASS)) {
                hasChanged = true
                label.classList.add(HIDDEN_CLASS)
              }
            })
            fieldset.querySelectorAll('.product-form__input input[type="radio"]:not(.disabled) + label').forEach((label) => {
              if (label.classList.contains(HIDDEN_CLASS)) {
                label.classList.remove(HIDDEN_CLASS)
              }
            })
            if (hasChanged) {
              fieldset.querySelector('input:not(.disabled)').click()
            }
          }) 
        })
        selects.forEach((select) => {
          select.querySelectorAll('option').forEach((option) => {
            if (disabledOptions.includes(option.value)) {
              if (!option.classList.contains(HIDDEN_CLASS)) {
                option.classList.add(HIDDEN_CLASS)
              }
            } else {
              if (option.classList.contains(HIDDEN_CLASS)) {
                option.classList.remove(HIDDEN_CLASS)
              }
            }
            
          })
        })
      }
    }

  }

  customElements.define("td-out-of-stock-checkbox", OOSCheckbox);
}

if (!customElements.get("td-sticky-atc")) {
  class TDStickyATC extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.initializeSticky()
        this.attachListeners()
      })
    }

    initializeSticky() {
      const observerForSticky = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                document.querySelector('.td-main-product__sticky').style.bottom = String(0 - document.querySelector('.td-main-product__sticky').clientHeight) + "px";
                const mobileColorSwatch = document.querySelector('.td-main-product__sticky-mobile-color-swatch');
                if (mobileColorSwatch.classList.contains('active')) {
                    mobileColorSwatch.classList.remove('active');
                    document.querySelector('.td-mobile-icon-arrow').classList.remove('active');
                }
            } else {
                document.querySelector('.td-main-product__sticky').style.bottom = "0px";
            }
        });
      });

      const targetElement = document.querySelector('.product__info-wrapper');
      observerForSticky.observe(targetElement);
    }

    attachListeners() {
      document.addEventListener('td:variant-changed', this.handleVariantChanged.bind(this))
    }

    handleVariantChanged({detail}) {

      // console.log("THIS RAN", detail)
      // console.log(this.querySelectorAll('.td-main-product__sticky-variant-text'))
      // detail.variant.options.forEach((option) => {
        
      //   const matchingOption =  this.querySelector(`option[value="${option}"]`)
      //   if (matchingOption) {
      //     console.log(matchingOption.closest('select').querySelector('option[selected]'))
      //     console.log(matchingOption)
      //     matchingOption.closest('select').querySelector('option[selected="selected"]').removeAttribute('selected')
      //     matchingOption.closest('select').value = option
      //     matchingOption.setAttribute('selected','selected')
      //     // matchingOption.selected = true
      //     // matchingOption.closest('select').value = option
      //   }
      // })
    }

  }

  customElements.define("td-sticky-atc", TDStickyATC);
}


// if (document.querySelectorAll('.td-main-product variant-radios').length > 0) {
//   document.querySelectorAll('.td-main-product variant-radios').forEach((radio) => {
//       radio.querySelectorAll('.product-form__input label').forEach((item, index) => {
//           item.addEventListener('click', () => {
//               variantSelectionOnSticky(radio, index);
//           })
//       });
//   })
// }

// if (document.querySelectorAll('.td-main-product__sticky variant-selects').length > 0) {
//   document.querySelectorAll('.td-main-product__sticky variant-selects').forEach(select => {
//       select.addEventListener('change', () => {
//           document.querySelectorAll('.td-main-product variant-radios').forEach(radio => {
//               radio.querySelectorAll('.product-form__input input').forEach((item, index) => {
//                   if (item.value == select.querySelector('select').value) {
//                       document.querySelectorAll('.td-main-product variant-radios input')[index].checked = true;
//                       variantSelectionOnSticky(radio, index);
//                   }
//               })
//           })
//       })
//   })
// }

// function variantSelectionOnSticky(radio, index) {
//   if (document.querySelectorAll('.td-main-product variant-radios').length > 0) {
//       const variantLength = document.querySelectorAll('.td-product-variant-picker__selected-variant').length;
//       document.querySelectorAll('.td-product-variant-picker__selected-variant')[variantLength - 1].innerHTML = radio.querySelectorAll('.product-form__input input')[index].value;
//       document.querySelectorAll('.td-main-product__sticky-variant-text')[variantLength - 1].innerHTML = radio.querySelectorAll('.product-form__input input')[index].value;
//       document.querySelectorAll('.td-main-product__sticky select').forEach(item => {
//           item.value = radio.querySelectorAll('.product-form__input input')[index].value;
//       })

//       setTimeout(() => {
//           if (document.querySelector('.td-main-product .product-form__submit') && document.querySelector('.td-main-product .product-form__submit > span').textContent.includes("Add to cart")) {
//               let html = 'ADD TO CART<span class="td-buy-buttons__price">' + radio.querySelectorAll('.product-form__input input')[index].getAttribute('data-price') + '</span>';
//               document.querySelector('.td-main-product .product-form__submit > span').innerHTML = html;
//               document.querySelectorAll('.td-main-product .product-form__submit').forEach((item, index) => {
//                   if (index > 0) {
//                       item.innerHTML = document.querySelectorAll('.td-main-product .product-form__submit')[0].innerHTML;
//                       item.removeAttribute("disabled");
//                   }
//               })
//           } else {
//               document.querySelectorAll('.td-main-product .product-form__submit').forEach((item, index) => {
//                   if (index > 0) {
//                       item.innerHTML = document.querySelectorAll('.td-main-product .product-form__submit')[0].innerHTML;
//                       item.setAttribute("disabled", "disabled");
//                   }
//               })
//           }
//       }, 400);
//   }
// }

if (document.querySelector('.td-main-product__go-to-review')) {
    document.querySelector('.td-main-product__go-to-review').addEventListener('click', () => {
        if (document.querySelector('.junip-product-review')) {
            document.querySelector('.junip-product-review').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
    })
}